module.exports = __webpack_public_path__ + "img/template.47290b4b.svg";